const SnackbarAlertReducer = (state = {}, action ) => {
    if(action.type === "UPDATE_SNACKBARALERT"){
        return action.SnackbarAlert 
    }
    return state
}
export default SnackbarAlertReducer
